
import { useMemo } from 'react';
import { useSiteBookings } from '@/hooks/useSiteBookings';
import { useSiteBookingStatus } from '@/hooks/useSiteBookingStatus';

export const useMapSiteBookingStatus = (siteId: string, dateRange?: { start?: Date; end?: Date }) => {
  console.log(`[useMapSiteBookingStatus] Called for siteId: ${siteId}, dateRange:`, dateRange);
  
  const { bookings } = useSiteBookings(siteId);
  console.log(`[useMapSiteBookingStatus] Retrieved ${bookings.length} bookings for site ${siteId}:`, bookings);
  
  const { bookedNow, isBookedForDateRange } = useSiteBookingStatus(bookings, dateRange);
  console.log(`[useMapSiteBookingStatus] Site ${siteId} status - bookedNow: ${bookedNow}, isBookedForDateRange: ${isBookedForDateRange}`);
  
  return useMemo(() => {
    console.log(`[useMapSiteBookingStatus] Site ${siteId} - computing marker status - bookedNow: ${bookedNow}, isBookedForDateRange: ${isBookedForDateRange}`);
    
    // Determine marker color based on booking status
    if (bookedNow) {
      console.log(`[useMapSiteBookingStatus] Site ${siteId} marked as CURRENTLY BOOKED (red)`);
      return {
        status: 'currently-booked' as const,
        color: '#ef4444', // red-500
        backgroundColor: '#fef2f2', // red-50
        label: 'Currently Booked'
      };
    }
    
    if (dateRange?.start && dateRange?.end && isBookedForDateRange) {
      console.log(`[useMapSiteBookingStatus] Site ${siteId} marked as BOOKED FOR DATES (orange)`);
      return {
        status: 'booked-for-dates' as const,
        color: '#f97316', // orange-500
        backgroundColor: '#fff7ed', // orange-50
        label: 'Booked for Selected Dates'
      };
    }
    
    console.log(`[useMapSiteBookingStatus] Site ${siteId} marked as AVAILABLE (green)`);
    return {
      status: 'available' as const,
      color: '#22c55e', // green-500
      backgroundColor: '#f0fdf4', // green-50
      label: 'Available'
    };
  }, [siteId, bookedNow, isBookedForDateRange, dateRange]);
};
